import React from "react";
import styles from "./InfoSidebar.module.css";
import sidebarStyles from "../Sidebar.module.css";
import img from "../../../assets/imgs/List_PFP.png";
import { NavLink, useLocation } from "react-router-dom";

function InfoSidebar() {
  const location = useLocation();

  return (
    <div className={`${sidebarStyles.sidebarBase} ${styles.infoSidebar}`}>
      <div className={styles.ImgSection}>
        <img src={img} alt="Logo" className={styles.Img} />
        <div className={styles.title}>
          Payable <br />
          register
        </div>
      </div>

      <nav className={styles.menu}>
        <NavLink
          to="/myfinv2/overview"
          className={`${styles.menuItem} ${
            location.pathname === "/myfinv2/overview" ? styles.active : ""
          }`}
        >
          Overview
        </NavLink>

        <NavLink
          to="/myfinv2/listing"
          className={`${styles.menuItem} ${
            location.pathname === "/myfinv2/listing" ? styles.active : ""
          }`}
        >
          Listing
        </NavLink>

        <NavLink
          to="/myfinv2/computecalculation"
          className={`${styles.menuItem} ${
            location.pathname === "/myfinv2/computecalculation"
              ? styles.active
              : ""
          }`}
        >
          Compute calculations
        </NavLink>
      </nav>
    </div>
  );
}

export default InfoSidebar;
